package com.picme.actuals

import com.lightningkite.kiteui.Blob
import org.w3c.files.BlobPropertyBag

actual fun ByteArray.toBlob(type: String):Blob = org.w3c.files.Blob(arrayOf(this.asDynamic()), options = BlobPropertyBag(type = type))